import React, { useState } from "react";
import { useTranslation, Link } from "gatsby-plugin-react-i18next";
import { StaticImage } from "gatsby-plugin-image";

import MenuDevision from "./sub-nav/menu-devision";
import MenuIndustries from "./sub-nav/menu-industries";
import MenuServices from "./sub-nav/menu-services";
import MenuTechnologies from "./sub-nav/menu-technologies";

import * as styles from "../assets/sass/modules/_header.module.scss";

const Header = () => {
  const { t } = useTranslation();

  const [menuToggle, setMenuState] = useState(false);

  const handleToggleMenu = (e) => {
    setMenuState(!menuToggle);
  };

  const closeMobileMenu = () => setMenuState(false);

  return (
    <header className={styles.navbar}>
      <div className={`${styles.navbarContainer} container`}>
        <Link to="/" onClick={closeMobileMenu}>
          <StaticImage
            src="../assets/images/devision-logo.svg"
            alt="Devision Logo"
          />
        </Link>
        <div
          className={
            menuToggle
              ? `${styles.menuWrapper} ${styles.showMenu}`
              : styles.menuWrapper
          }
        >
          <nav className={styles.mainMenu}>
            <ul>
              <li className={`${styles.menuItem} ${styles.menuDropDownFull}`} key="1">
                <span className={styles.menuItemLink}>
                  {t("SERVICES_AND_EXPERTISE")}{" "}
                  <i className="dei-chevron-down" />
                </span>
                <div className={styles.menuDropDown}>
                  <MenuServices />
                </div>
              </li>
              <li className={`${styles.menuItem} ${styles.menuDropDownFull}`} key="2">
                <span className={styles.menuItemLink}>
                  {t("TECHNOLOGIES")} <i className="dei-chevron-down" />
                </span>
                <div className={styles.menuDropDown}>
                  <MenuTechnologies />
                </div>
              </li>
              <li className={`${styles.menuItem} ${styles.menuDropDownFull}`} key="3">
                <span className={styles.menuItemLink}>
                  {t("INDUSTRIES")} <i className="dei-chevron-down" />
                </span>
                <div className={styles.menuDropDown}>
                  <MenuIndustries />
                </div>
              </li>
              <li className={`${styles.menuItem} ${styles.menuDropDownFull}`} key="4">
                <span className={styles.menuItemLink}>
                  {t("WHY_DEVISION")} <i className="dei-chevron-down" />
                </span>
                <div className={styles.menuDropDown}>
                  <MenuDevision />
                </div>
              </li>
              <li className={styles.menuItem} key="5">
                <Link
                  className={styles.menuItemLink}
                  to="/our-work"
                  activeClassName={styles.menuItemLinkActive}
                >
                  {t("OUR_WORK")}
                </Link>
              </li>
              <li className={styles.menuItem} key="6">
                <Link
                  className={styles.menuItemLink}
                  to="/careers"
                  activeClassName={styles.menuItemLinkActive}
                >
                  {t("CAREERS")}{" "}
                  <span className={styles.menuLabel}>{t("HIRING")}</span>
                </Link>
              </li>
            </ul>
          </nav>
          <div className={styles.utilities}>
            <Link to="/contact-us" className="btn btn-primary">
              {t("LETS_TEAM_UP")}
            </Link>
          </div>
        </div>
        <button onClick={handleToggleMenu} className={styles.mobileMenu}>
          <i
            className={menuToggle ? "dei-cross" : "dei-menu"}
            aria-label="Toggle menu"
          ></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
